<template>
    <main :dir="isLangEnglish() ? 'ltr' : 'rtl'" style="overflow: hidden;">
        <div class="mobile-menu" data-aos="fade-right" v-if="showMenu">

            <div class="links" :class="{ 'links': isLangEnglish(), 'links-k': !isLangEnglish() }">
                <router-link :to="{ name: 'home' }">
                    <span v-if="selectedLang() == 'en'">Home</span>
                    <span v-if="selectedLang() == 'ar'">رئيسي</span>
                    <span v-if="selectedLang() == 'ku'">سەرەکی</span>
                </router-link>
                <router-link :to="{ name: 'whoweare' }">
                    <span v-if="selectedLang() == 'en'">Who We Are</span>
                    <span v-if="selectedLang() == 'ar'"><bdo dir="rtl">من نحن</bdo></span>
                    <span v-if="selectedLang() == 'ku'"><bdo dir="rtl">ئێمە کێین</bdo></span>
                </router-link>
                <router-link :to="{ name: 'wellness' }">
                    <span v-if="selectedLang() == 'en'">Kurdos Wellness</span>
                    <span v-if="selectedLang() == 'ar'"><bdo dir="rtl">صحة</bdo></span>
                    <span v-if="selectedLang() == 'ku'"><bdo dir="rtl">تەندروستی</bdo></span>
                </router-link>
                <router-link :to="{ name: 'medtech' }">
                    <span v-if="selectedLang() == 'en'">Kurdos MedTech</span>
                    <span v-if="selectedLang() == 'ar'"><bdo dir="rtl">التكنولوجيا الطبية</bdo></span>
                    <span v-if="selectedLang() == 'ku'"><bdo dir="rtl">تەکنەلۆژیای پزیشکی</bdo></span>
                </router-link>
                <router-link :to="{ name: 'infrastructure' }">
                    <span v-if="selectedLang() == 'en'">Kurdos Infra</span>
                    <span v-if="selectedLang() == 'ar'"><bdo dir="rtl"> بنية کوردوس </bdo></span>
                    <span v-if="selectedLang() == 'ku'"><bdo dir="rtl">ژێرخانی کوردۆس</bdo></span>
                </router-link>
                <router-link :to="{ name: 'contact' }"> <span v-if="selectedLang() == 'en'">Contact Us</span>
                    <span v-if="selectedLang() == 'ar'"><bdo dir="rtl">اتصل بنا</bdo></span>
                    <span v-if="selectedLang() == 'ku'"><bdo dir="rtl">پەیوەندیمان پێوە بکەن</bdo></span></router-link>
            </div>
        </div>
        <header ref="menuRef">
            <div>
                <router-link :to="{ name: 'healthcare' }" class="skip">
                    <div>
                        <img v-if="!darkmode" src="/images/healthcare_logo_black.png" style="width: 98px" />
                        <img v-else src="/images/healthcare_logo.png" style="width: 98px" />

                    </div>
                </router-link>
            </div>
            <div class="links links2">
                <router-link :to="{ name: 'home' }">
                    <span v-if="selectedLang() == 'en'">Home</span>
                    <span v-if="selectedLang() == 'ar'">رئيسي</span>
                    <span v-if="selectedLang() == 'ku'">سەرەکی</span>
                </router-link>
                <router-link :to="{ name: 'whoweare' }">
                    <span v-if="selectedLang() == 'en'">Who We Are</span>
                    <span v-if="selectedLang() == 'ar'"><bdo dir="rtl">من نحن</bdo></span>
                    <span v-if="selectedLang() == 'ku'"><bdo dir="rtl">ئێمە کێین</bdo></span>
                </router-link>
                <router-link :to="{ name: 'wellness' }">
                    <span v-if="selectedLang() == 'en'">Kurdos Wellness</span>
                    <span v-if="selectedLang() == 'ar'"><bdo dir="rtl">صحة</bdo></span>
                    <span v-if="selectedLang() == 'ku'"><bdo dir="rtl">تەندروستی</bdo></span>
                </router-link>
                <router-link :to="{ name: 'medtech' }">
                    <span v-if="selectedLang() == 'en'">Kurdos MedTech</span>
                    <span v-if="selectedLang() == 'ar'"><bdo dir="rtl">التكنولوجيا الطبية</bdo></span>
                    <span v-if="selectedLang() == 'ku'"><bdo dir="rtl">تەکنەلۆژیای پزیشکی</bdo></span>
                </router-link>
                <router-link :to="{ name: 'infrastructure' }">
                    <span v-if="selectedLang() == 'en'">Kurdos Infra</span>
                    <span v-if="selectedLang() == 'ar'"><bdo dir="rtl"> بنية کوردوس </bdo></span>
                    <span v-if="selectedLang() == 'ku'"><bdo dir="rtl">ژێرخانی کوردۆس</bdo></span>
                </router-link>
                <router-link :to="{ name: 'contact' }">
                    <span v-if="selectedLang() == 'en'">Contact Us</span>
                    <span v-if="selectedLang() == 'ar'"><bdo dir="rtl">اتصل بنا</bdo></span>
                    <span v-if="selectedLang() == 'ku'"><bdo dir="rtl">پەیوەندیمان پێوە بکەن</bdo></span>
                </router-link>
            </div>
            <div class="menu">

                <div class="language-dropdown" style="position: relative;">
                    <div class="dropdown-menu" :class="isLangEnglish() ? 'dropdown-menu-right' : 'dropdown-menu-left'">
                        <button class="dropdown-item" @click="selectLang('en')">English</button>
                        <button class="dropdown-item" @click="selectLang('ku')">کوردی</button>
                        <button class="dropdown-item" @click="selectLang('ar')">عربي</button>
                    </div>
                    <button class="language_selector">
                        <i class="bi bi-globe2" :class="{ 'light-globe': darkmode }"></i>
                    </button>
                </div>


                <button @click="toggleDark()" style="display: flex;align-items: center;justify-content: center;">
                    <svg   v-if="!darkmode" xmlns="http://www.w3.org/2000/svg" width="20" height="20" :fill="!darkmode ? '#073762' : '#fff'"
                        viewBox="0 0 256 256">
                        <path
                            d="M233.54,142.23a8,8,0,0,0-8-2,88.08,88.08,0,0,1-109.8-109.8,8,8,0,0,0-10-10,104.84,104.84,0,0,0-52.91,37A104,104,0,0,0,136,224a103.09,103.09,0,0,0,62.52-20.88,104.84,104.84,0,0,0,37-52.91A8,8,0,0,0,233.54,142.23ZM188.9,190.34A88,88,0,0,1,65.66,67.11a89,89,0,0,1,31.4-26A106,106,0,0,0,96,56,104.11,104.11,0,0,0,200,160a106,106,0,0,0,14.92-1.06A89,89,0,0,1,188.9,190.34Z">
                        </path>
                    </svg>
                    <svg class="animate-spin" v-else xmlns="http://www.w3.org/2000/svg" width="20" height="20" :fill="!darkmode ? '#073762' : '#fff'" viewBox="0 0 256 256"><path d="M120,40V16a8,8,0,0,1,16,0V40a8,8,0,0,1-16,0Zm72,88a64,64,0,1,1-64-64A64.07,64.07,0,0,1,192,128Zm-16,0a48,48,0,1,0-48,48A48.05,48.05,0,0,0,176,128ZM58.34,69.66A8,8,0,0,0,69.66,58.34l-16-16A8,8,0,0,0,42.34,53.66Zm0,116.68-16,16a8,8,0,0,0,11.32,11.32l16-16a8,8,0,0,0-11.32-11.32ZM192,72a8,8,0,0,0,5.66-2.34l16-16a8,8,0,0,0-11.32-11.32l-16,16A8,8,0,0,0,192,72Zm5.66,114.34a8,8,0,0,0-11.32,11.32l16,16a8,8,0,0,0,11.32-11.32ZM48,128a8,8,0,0,0-8-8H16a8,8,0,0,0,0,16H40A8,8,0,0,0,48,128Zm80,80a8,8,0,0,0-8,8v24a8,8,0,0,0,16,0V216A8,8,0,0,0,128,208Zm112-88H216a8,8,0,0,0,0,16h24a8,8,0,0,0,0-16Z"></path></svg>
                </button>
                <button class="menu-button-mobile" @click="showMenu = !showMenu" style="align-items: center;justify-content: center;">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" :fill="!darkmode ? '#073762' : '#fff'"
                        viewBox="0 0 256 256" v-if="!showMenu">
                        <path
                            d="M128,96a32,32,0,1,0,32,32A32,32,0,0,0,128,96Zm0,48a16,16,0,1,1,16-16A16,16,0,0,1,128,144ZM48,96a32,32,0,1,0,32,32A32,32,0,0,0,48,96Zm0,48a16,16,0,1,1,16-16A16,16,0,0,1,48,144ZM208,96a32,32,0,1,0,32,32A32,32,0,0,0,208,96Zm0,48a16,16,0,1,1,16-16A16,16,0,0,1,208,144Z">
                        </path>
                    </svg>
                    <svg  v-else xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                        :fill="!darkmode ? '#073762' : '#fff'" viewBox="0 0 256 256">
                        <path
                            d="M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z">
                        </path>
                    </svg>
                </button>
            </div>
        </header>

        <router-view></router-view>
    </main>
</template>

<script setup>
import { ref, onMounted, onUnmounted, watch, computed } from 'vue'
import { useRoute } from 'vue-router'
import { isLangEnglish } from '../utils/language_selector'
import { selectedLang } from '../utils/selected_lang'
import { isDark } from '../utils/theme'

const menuOpen = ref(false)
const menuRef = ref(null)
const showMenu = ref(false)

function selectLang(lang) {
    localStorage.setItem('healthcare_lang', lang)
    window.location.reload()
}

const route = useRoute();
watch(route, () => {
    showMenu.value = false
})
const closeMenu = () => {
    menuOpen.value = false
}

const unlockBodyScroll = () => {
    document.body.style.overflow = ''
}

const lockBodyScroll = () => {
    document.body.style.overflow = 'hidden'
}


const darkmode = ref(false);


function toggleDark() {
    document.body.classList.toggle('dark');
    if (document.body.classList.contains('dark')) {
        localStorage.setItem('healthcare_theme', 'dark');
        darkmode.value = true
    } else {
        localStorage.setItem('healthcare_theme', 'light');
        darkmode.value = false
    }
}

watch(showMenu, (newValue) => {
    if (newValue) {
        lockBodyScroll()
    } else {
        unlockBodyScroll()
    }
})

const handleClickOutside = (event) => {
    if (menuRef.value && !menuRef.value.contains(event.target)) {
        closeMenu()
    }
}

onMounted(() => {
    document.addEventListener('click', handleClickOutside)
    if (isDark()) {
        document.body.classList.add('dark');
        darkmode.value = true
    }
})

onUnmounted(() => {
    document.removeEventListener('click', handleClickOutside)
})

</script>

<style scoped>
* {
    font-family: 'Franklin Gothic Medium', 'Arial Narrow', Arial, sans-serif !important;
    font-weight: 400 !important;
    line-height: 1.2rem !important;
}


.animate-spin {
    animation: spin 0.4s linear;
}
@keyframes spin {
    from {
        transform: rotate(0deg);
    }
    to {
        transform: rotate(100deg);
    }
}
main {
    min-height: 100vh;
}
.dark main{
    background: #131313 !important;
}


header {
    padding: 20px 50px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
}

.dark header {
    background: rgb(21, 21, 21);
}

header .logo {
    display: flex;
    align-items: center;
}

.links a {
    font-size: 14px;
}

.light-globe {
    color: #fff !important;
}

.links {
    display: flex;
    gap: 15px;
    z-index: 200 !important;
}

.menu {
    display: flex;
    gap: 10px;

}

.menu button {
    border: none;
    cursor: pointer;
    width: 40px;
    height: 40px;
    border-radius: 20px;
    background: #DCE5EF;
}

.dark .menu button {
    background: rgb(94, 94, 94);
}

a:not(.skip) {
    padding: 5px 14px;
    text-transform: uppercase;
    color: #515151;
}

.router-link-exact-active {
    color: #E43D34 !important;
    position: relative;
}

.router-link-exact-active::after {
    position: absolute;
    content: '';
    background: #E43D34 !important;
    width: 100%;
    height: 4px;
    top: 180%;
    left: 0;
    border-radius: 10px;
}

.mobile-menu .links .router-link-exact-active::after {
    display: none;
}

.mobile-menu .links-k .router-link-exact-active::after {
    display: none;
}


.mobile-menu {
    position: fixed;
    z-index: 1000;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    top: 0;
    left: 0;
    bottom: 0;
    background: rgba(220, 229, 239, 0.9);
    backdrop-filter: blur(10px);

}
.dark .mobile-menu{
    background: rgba(0, 0, 0, 0.8);
}

.mobile-menu .links {
    flex-direction: column;
    font-size: large;
}

.dropdown-menu {
    display: none;
    position: absolute;
    top: 40px;
    background: #fff;
    border: 1px solid #eee;
    border-radius: 15px;
    box-shadow: 0 2px 8px #0001;
    min-width: 120px;
    z-index: 1001;
    flex-direction: column;
    padding: 10px;
    gap: 10px;
}

.dark .dropdown-menu {
    background: rgb(31, 31, 31);
    border: 1px solid #333;
}
.dark .dropdown-menu a{
    color: #fff !important;
}

.dropdown-menu-right {
    right: 0;
}

.dropdown-menu-left {
    right: -70px;
}

.language-dropdown {
    position: relative;
}

.language-dropdown:hover .dropdown-menu {
    display: flex;
}

.dropdown-item {
    width: 100% !important;
}

.dark .dropdown-item {
    color: white !important;
}

.dropdown-item:hover {
    width: 100% !important;
    opacity: 0.6;
}

.menu-button-mobile {
    display: none;
    z-index: 1000;
}

@media (max-width:1024px) {
    .menu-button-mobile {
        display: flex;
    }

    .links2 {
        display: none;
    }

    header {
        padding: 10px 20px;
    }

    .menu-button {
        display: block;
    }
}

.language_selector {
    width: 30px;
    height: 30px;
    background: #DCE5EF;
    color: #073762;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    border-radius: 100%;
    font-size: 14px;
}

.close-button {
    margin: 30px 40px;
    position: absolute;
    right: 0;
    top: 0;
    width: 40px;
    height: 40px;
    border: 1px solid rgb(231, 231, 231);
    background: whitesmoke;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 100%;
    cursor: pointer;
    transition: 0.1s ease-in-out;
}

.close-button:hover {
    transform: scale(0.9);
}
</style>
